import { get, map, keyBy } from 'lodash';

import { UPSELL_RECOMMENDATION_TYPES, UNISIZE } from 'constants/cartUpsells';
import Model from 'models';
import { generateProductUrl } from 'utils/Url';

import Size from './Size';

const CartUpsell = class extends Model {
  get productType() {
    switch (get(this._data, ['productType'])) {
      case 'Socks':
        return UPSELL_RECOMMENDATION_TYPES.SOCKS;
      case 'Apparel':
        return UPSELL_RECOMMENDATION_TYPES.APPAREL;
      case 'Gift Cards':
        return UPSELL_RECOMMENDATION_TYPES.GIFT_CARDS;
      case 'Shoes':
      default:
        return UPSELL_RECOMMENDATION_TYPES.SHOES;
    }
  }

  get image() {
    return {
      src: get(this._data, ['image', 'src']),
      alt: get(this._data, ['image', 'alt']),
    };
  }

  get productName() {
    return get(this._data, 'productName');
  }

  get colorName() {
    return get(this._data, 'colorName');
  }

  get handle() {
    return get(this._data, 'handle');
  }

  get colors() {
    return get(this._data, 'swatchColors');
  }

  get swatchImageOverride() {
    return get(this._data, 'swatchImageOverride');
  }

  get sizes() {
    return map(get(this._data, 'sizes'), size => new Size(size));
  }

  get mappedSizes() {
    return keyBy(this.sizes, 'label');
  }

  get price() {
    return get(this.sizes[0], 'price');
  }

  get isUnisize() {
    return this.sizes.length === UNISIZE;
  }

  get linkUrl() {
    return generateProductUrl(this.handle);
  }
};

export default CartUpsell;
